import BaseError from './BaseError';

class RewardsError extends BaseError {
  constructor(message: string, fileName?: string, lineNumber?: number) {
    super('RewardsError', message, fileName, lineNumber);
  }
}

export default RewardsError;
